import { type MembershipRole, type Permission } from '@irl/types';
import { hasPermission as checkRolePermission } from '@irl/validation';

export type { Permission };

export interface ChatAccessContext {
  chatId: string;
  role: MembershipRole;
  customPermissions: Permission[];
}

export function checkPermission(
  isGlobalOperator: boolean,
  chat: ChatAccessContext | undefined,
  required: Permission,
): boolean {
  if (isGlobalOperator) {
    return true;
  }
  if (!chat) {
    return false;
  }
  return checkRolePermission(chat.role, chat.customPermissions, required);
}

export function hasPermissionInAnyChat(
  isGlobalOperator: boolean,
  chats: ChatAccessContext[],
  required: Permission,
): boolean {
  if (isGlobalOperator) {
    return true;
  }
  return chats.some((chat) => checkRolePermission(chat.role, chat.customPermissions, required));
}

export function hasPermissionInChats(
  isGlobalOperator: boolean,
  chats: ChatAccessContext[],
  chatIds: string[],
  required: Permission,
): boolean {
  if (isGlobalOperator) {
    return true;
  }
  const idSet = new Set(chatIds);
  return chats
    .filter((chat) => idSet.has(chat.chatId))
    .some((chat) => checkRolePermission(chat.role, chat.customPermissions, required));
}
